import React from 'react';
import { Col, Row } from 'antd';

import { AditionalItemProps } from './types';
import { ConditionCard } from '../../ConditionCard';
import { PartialInputField } from './PartialInputField';
import { InfoPartialInputList } from './InfoPartialInputList';
import { useInputAndInputPartial } from './_hooks/useInputAndInputPartial';

export function InputAndInputPartial({ additionalItem }: Readonly<AditionalItemProps>): JSX.Element {
	const { id, title_1, title_2, unit_1, unit_2 } = additionalItem;

	const {
		formFieldName,
		localAdditionalItem,
		worstRisk,
		isAddValueOneDisabled,
		isAddValueTwoDisabled,
		isCalculatingScore,
		handleAddValueOneClick,
		handleAddValueTwoClick,
		handleRemoveAdditionalItemClick
	} = useInputAndInputPartial({ additionalItem });

	const hasResults = !!localAdditionalItem?.results?.length;

	return (
		<Row gutter={[0, 15]} key={id}>
			<Col sm={24} lg={18}>
				<Row gutter={[0, 20]}>
					<PartialInputField
						title={title_1}
						unit={unit_1}
						fieldName={[...formFieldName, 'additional_items', id, 'value_1']}
						isAddDisabled={isAddValueOneDisabled}
						onAdd={handleAddValueOneClick}
					/>
					<PartialInputField
						title={title_2}
						unit={unit_2}
						fieldName={[...formFieldName, 'additional_items', id, 'value_2']}
						isAddDisabled={isAddValueTwoDisabled}
						onAdd={handleAddValueTwoClick}
					/>
				</Row>
			</Col>
			<Col span={24}>
				{hasResults && (
					<InfoPartialInputList items={localAdditionalItem} onDeleteValue={handleRemoveAdditionalItemClick} />
				)}
			</Col>
			<Col span={24}>
				<ConditionCard result={worstRisk} isLoading={isCalculatingScore} />
			</Col>
		</Row>
	);
}
